import { Component } from "react";
import { Divider } from "primereact/divider";
import { Link } from "react-router-dom";
import { AddPageHeader } from "../Common/Utils";

class About extends Component {
  render() {
    return (
      <div>
        {AddPageHeader("About")}
        <div className="reduce-width">
          <Divider align="center">
            <h1>About</h1>
          </Divider>
          <div className="privacy-terms-reduced-width">
            <p>
              The Consular Affairs Center is a nongovernmental, nonpartisan
              research institute for consular affairs and diplomatic networks.
            </p>
            <p>
              <b>Origins</b>
            </p>
            <p>
              The inception of the Center stemmed from three principal
              observations. First, it recognized the substantial budget and
              personnel dedicated to consular affairs, both within central
              administration and across diplomatic networks. Second, the growing
              involvement of diverse governmental, corporate, and nonprofit
              stakeholders in the field was notable. Third, a gap was
              identified: the absence of a dedicated nongovernmental,
              nonpartisan research institute addressing these questions.
            </p>
            <p>
              <b>Mission and audience</b>
            </p>
            <p>
              Our mission is twofold: advancing research and supporting
              practitioners.
            </p>
            <p>
              Our resources and publications cater to an audience spanning
              academic, corporate, governmental, and nonprofit organizations,
              which encompass consular officials, diplomats, migration lawyers,
              researchers, and travel industry professionals. Additionally, we
              serve individuals such as business travelers, migrants, and
              tourists. Operating from multiple countries, the Center has a
              global reach through its network of research fellows,
              contributors, correspondents, and partners.
            </p>
            <p>
              <b>The Center's resources and publications include:</b>
            </p>
            <ul
              style={{
                display: "inline-list-item",
                listStyle: "square",
                listStylePosition: "inside",
                paddingInlineStart: "0px",
              }}
            >
              <li>The present website;</li>
              <li>
                <Link
                  to="/the-consular-bibliography"
                  style={{
                    color: "black",
                  }}
                >
                  The Consular Bibliography
                </Link>
                ;
              </li>
              <li>
                <Link
                  to="/the-consular-daily-press-review"
                  style={{
                    color: "black",
                  }}
                >
                  The Consular Daily Press Review
                </Link>
                ;
              </li>
              <li>The Consular Journal (TBA);</li>
              <li>
                <a
                  href="https://magazine.consularaffairs.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "black",
                    textDecoration: "underline",
                  }}
                >
                  The Consular Magazine
                </a>
                ;
              </li>
              <li>
                <Link
                  to="/the-consular-newsletter"
                  style={{
                    color: "black",
                  }}
                >
                  The Consular Newsletter
                </Link>
                ;
              </li>
              <li>
                <a
                  href="https://zenodo.org/communities/theconsularrepository/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "black",
                    textDecoration: "underline",
                  }}
                >
                  The Consular Repository
                </a>
                ; and
              </li>
              <li>
                <a
                  href="https://arcg.is/1TDPiy1"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "black",
                    textDecoration: "underline",
                  }}
                >
                  The Diplomatic and Consular Networks Database and Rankings
                </a>
                .
              </li>
            </ul>
            <p>
              The views expressed are solely those of the author(s), not of the
              Center.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default About;
